import { Controller } from "@hotwired/stimulus"
import { canHover } from '../helpers/media_helpers'

const LEAVE_DELAY = 300

export default class extends Controller {
  static targets = ['hoverable']

  #leaveTimer

  connect() {
    this.hoverableTargets.forEach(elem => {
      elem.addEventListener('mouseenter', this.#enter)
      elem.addEventListener('mouseleave', this.#scheduleLeave)
    })
  }

  disconnect() {
    this.hoverableTargets.forEach(elem => {
      elem.removeEventListener('mouseenter', this.#enter)
      elem.removeEventListener('mouseleave', this.#scheduleLeave)
    })

    this.#cancelScheduledLeave()
  }

  #enter = () => {
    if (!canHover()) return

    this.#cancelScheduledLeave()
    this.dispatch('enter')
  }

  #scheduleLeave = () => {
    if (!canHover()) return

    this.#cancelScheduledLeave()
    this.#leaveTimer = setTimeout(() => this.dispatch('leave'), LEAVE_DELAY)
  }

  #cancelScheduledLeave() {
    clearTimeout(this.#leaveTimer)
  }
}
